import { FormControlLabel, Tooltip } from '@mui/material';

import { LabeledSwitch } from '~/components/common/LabeledSwitch';

export function PeekModeSwitch({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <Tooltip title="Hover over a row to preview it (Space)">
      <FormControlLabel
        sx={{ ml: 0, mr: 0, my: -0.5 }}
        control={
          <LabeledSwitch checked={checked} onChange={(event) => onChange(event.target.checked)} />
        }
        label="Peek mode"
        slotProps={{
          typography: { variant: 'button', fontSize: '0.8125rem', color: 'primary' },
        }}
      />
    </Tooltip>
  );
}
